(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/core/assets/javascripts/utils/ui.js') >= 0) return;  svs.modules.push('/components/numbergames/core/assets/javascripts/utils/ui.js');

'use strict';

function focusElement(el) {
  el.focus();
  $(el).addClass('svs-keyboard-focus');
}
svs.numbergames.core.utils.ui = {
  focusElement
};

 })(window);